import {Container, Grid, Paper, TableBody, TableHead} from "@mui/material";
import {
    StyledButtonContainer, StyledButtonOrange,
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import * as DataProvider from "../../logic/DataProvider";
import dayjs from "dayjs";
import {GetLookupValueName} from "../../logic/LookupHelper";
import {GetBrokerageAgreementTitle} from "../../logic/EntityTitleHelper";
import {useNavigate} from "react-router-dom";

const LimitsPage = () => {
    const navigate = useNavigate();
    const [limits, setLimits] = useState([]);
    const [agreements, setAgreements] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.limits) {
                let entities = bundle.limits;
                setLimits(JSON.parse(JSON.stringify(entities)));
            }
            if (bundle.agreements) {
                let agreements = bundle.agreements;
                setAgreements(JSON.parse(JSON.stringify(agreements)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleRequestNew = () => {
        navigate(`request`);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleRequestNew}>
                        New
                    </StyledButtonOrange>
                </Grid>
            </StyledButtonContainer>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={6}>Asset</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Brokerage Agreement</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Extension Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Total Volume</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Reminder Volume</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Extension Number</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {limits && limits.map((limit) => (
                            <StyledTableBodyRow key={limit.id}>
                                <StyledTableCell>{GetLookupValueName('asset', limit.assetId)}</StyledTableCell>
                                <StyledTableCell>{GetBrokerageAgreementTitle(agreements.find(e => e.id === limit.brokerageAgreementId))}</StyledTableCell>
                                <StyledTableCell>{dayjs(limit.extensionDate).toDate().toDateString()}</StyledTableCell>
                                <StyledTableCell>{limit.totalVolume}</StyledTableCell>
                                <StyledTableCell>{limit.reminderVolume}</StyledTableCell>
                                <StyledTableCell>{limit.extensionNumber}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default LimitsPage;